<template lang="pug">
  .b-crm-tile-lead
    ._card(@click="$emit('open')")
      ._card-top
        span._card-date {{ lead.date }}
        //- непрочитанные напоминания по заявке — считает CrmKanbanApi
        NotificationCount._notification-count(:count="lead.notificationCount")
        EllipsisMenu(v-if="menuItems.length" :items="menuItems" @click.native.stop)
      p._card-name {{ lead.name }}
      ._card-phone(v-if="lead.phone")
        span._card-phone-value {{ lead.phone }}
        span._card-phone-label телефон
      p._card-description {{ lead.description }}
      ._card-reason(v-if="lead.rejectionReason")
        span._card-reason-label Причина отказа
        span._card-reason-value {{ lead.rejectionReason }}
    ._projects(v-if="lead.projects && lead.projects.length")
      span._project(
      v-for="(project, index) in lead.projects"
      :key="project.id"
      :class="{ last: index === lead.projects.length - 1 }"
      ) {{ project.name }}
</template>

<script>
import EllipsisMenu from '@/components/EllipsisMenu.vue';
import NotificationCount from '@/components/base/NotificationCount.vue';

export default {
  name: 'CrmTileLeadUi',
  components: { EllipsisMenu, NotificationCount },
  props: {
    lead: {
      type: Object,
      required: true,
    },
  },
  computed: {
    // подтверждение и запрос — на стороне CrmKanbanApi; право на удаление
    // считает она же и кладёт в саму карточку
    menuItems() {
      if (!this.lead.canRemove) return [];

      return [
        { text: 'Удалить', icon: 'trash', handler: () => this.$emit('remove') },
      ];
    },
  },
};
</script>

<style scoped lang="scss">
.crm-tile-lead {
  &__card {
    position: relative;
    background: var(--color-white);
    border-radius: 8px;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
    padding: 17px;
    cursor: pointer;
  }

  &__card-top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 16px;
  }

  // к правому краю, перед меню: дата остаётся слева и без счётчика
  &__notification-count {
    margin-right: auto;
  }

  &__card-date {
    font-size: 12px;
    color: var(--color-middle-gray);
  }

  &__card-name {
    font-weight: 500;
    font-size: 18px;
    color: var(--color-accent);
    margin-bottom: 16px;
  }

  &__card-phone {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
  }

  &__card-phone-value {
    font-weight: 500;
    font-size: 14px;
    color: var(--color-dark-gray);
  }

  &__card-phone-label {
    font-size: 14px;
    color: var(--color-middle-gray);
  }

  &__card-description {
    font-size: 12px;
    color: var(--color-middle-gray);
  }

  &__card-reason {
    display: flex;
    flex-direction: column;
    margin-top: 16px;
  }

  &__card-reason-label {
    font-size: 12px;
    color: var(--color-middle-gray);
  }

  &__card-reason-value {
    font-weight: 500;
    font-size: 14px;
    // тот же красный, что и у колонки «Отказ» (CLOSING_COLUMNS)
    color: #E21313;
    word-break: break-word;
  }

  &__projects {
    display: flex;
    flex-direction: column;
  }

  &__project {
    background: #D3EAFF;
    font-size: 12px;
    color: var(--color-accent);
    padding: 10px 17px;
    border-bottom: 1px solid var(--color-white);

    &.last {
      border-radius: 0 0 8px 8px;
      border-bottom: none;
    }
  }
}
</style>
